import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import '../assets/styles/settings.css';
import '../assets/styles/docs.scss';
import '../assets/styles/dashboard.scss';
import ViewProfile from '_components/Profile/ViewProfile';
import { BulletinBoard } from './BulletinBoard';
import { EditProfile } from './EditProfile';
import { Permissions } from './Permissions';
import { DocsList } from './DocsList';
import { notificationActions, permissionActions, inventoryActions, chatActions } from '../_actions';
import { userActions } from '../_actions';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import ChangePassword from 'ChangePassword';
import ErrorBoundary from '_components/ErrorBoundary';
import UpdateEmployeeTraining from 'EmployeeTraining';
import UserQualifications from 'UserQualifications';
import SystemManage from './SystemManage';
import Management from './Management';
import ApplicantsTab from 'ApplicantTab';
import { profileService } from '_services/profile.service';
import { docsService } from '_services/docs.service';
import { toast } from 'react-toastify';
import { handleErrorResponse } from '_helpers/helpers';
import { formatDate } from '_helpers/helpers';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import SmsNotification from 'SmsNotification/SmsNotification';
import { profileType } from '_constants';
import { ApplicationHistory } from 'Applicants/ApplicationHistory';
import { AlertPopup } from '../_components/AlertPopup';
import { authHeader, config } from '../_helpers';
import {
  ProfileHeader,
  TabNavigation,
  TabContent,
} from '../common/Profile';
import { DocumentButtons } from '../common/Profile';

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mainHtml: '',
      step: this.props.match.params.step,
      statusOpen: false,
      status: '',
      available: '',
      statusStep: '1',
      returnDateField: moment(),
      returnDate: '',
      permission: [],
      h1: '',
      admin: false, // Initialize admin status
      namePrefix: 'you', // Initialize namePrefix
      email: '', // Initialize email
      sms: 1,
      sendEmail: 1,
      unavailableErr: '',
      unavailableDescriptionErr: '',
      unavailableReason: 0,
      otherReason: '',
      applicant_hash: '',
      sendingDDForm: false,
      send_dd_form_confirm: false,
      reloadKey: 0,
      loader: false,
      mailSendOpen: false,
      message: '',
      alertPop: false,
      alertHead: '',
      alertMsg: '',
      alertFunction: '',
      request_rehire_doc: false,
      doc_request: '',
      request_rehire_doc_status: false,
    };
    this.changeTab = this.changeTab.bind(this);
    this.statusOpenModal = this.statusOpenModal.bind(this);
    this.statusCloseModal = this.statusCloseModal.bind(this);
    this.setStatusReturn = this.setStatusReturn.bind(this);
    this.setStep = this.setStep.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.cancel = this.cancel.bind(this);
    this.editProfile = this.editProfile.bind(this);
    this.viewHistory = this.viewHistory.bind(this);
    this.viewDetails = this.viewDetails.bind(this);
    this.openDdformConfirmModal = this.openDdformConfirmModal.bind(this);
    this.ddFormConfirmCloseModal = this.ddFormConfirmCloseModal.bind(this);
    this.sendDDForm = this.sendDDForm.bind(this);
    this.mailSendOpenModal = this.mailSendOpenModal.bind(this);
    this.mailSendCloseModal = this.mailSendCloseModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.sendMail = this.sendMail.bind(this);
    this.handleOnClickHandbook = this.handleOnClickHandbook.bind(this);
    this.documentRequest = this.documentRequest.bind(this);
    this.downloadAllDocuments = this.downloadAllDocuments.bind(this);
    this.downloadAllDocumentsAsPDF = this.downloadAllDocumentsAsPDF.bind(this);
    this.docRequestModalClose = this.docRequestModalClose.bind(this);
  }

  statusOpenModal() {
    this.setState({ statusOpen: true, statusStep: '1' });
  }

  mailSendOpenModal() {
    this.setState({ mailSendOpen: true, message: '', sendEmail: 1, sms: 1 });
  }

  mailSendCloseModal() {
    this.setState({ mailSendOpen: false });
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  closeAlert() {
    this.setState({
      alertPop: false,
    });
  }

  handleCheckbox(e) {
    const { name } = e.target;
    this.setState({
      [name]: e.target.checked ? 1 : 0,
    });
  }

  sendMail(hash) {
    let data = new FormData();
    this.mailSendCloseModal();
    const emailVal = this.state.sendEmail ? 1 : 0;
    const smsVal = this.state.sms ? 1 : 0;
    data.append('type', 'mail');
    data.append('email', emailVal);
    data.append('sms', smsVal);
    data.append('message', this.state.message);
    data.append('user_hash', hash);
    const self = this;
    fetch(config.apiUrl + '/api/employee/sendmails', {
      headers: authHeader(),
      method: 'POST',
      body: data,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.success) {
          self.setState({
            alertPop: true,
            alertHead: 'Success',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        } else {
          self.setState({
            alertPop: true,
            alertHead: 'Error',
            alertMsg: JSON.parse(JSON.stringify(data.message)),
            alertFunction: '',
          });
        }
      });
  }

  statusCloseModal() {
    this.setState({
      statusOpen: false,
      unavailableReason: 0,
      unavailableErr: '',
      unavailableDescriptionErr: '',
      otherReason: '',
    });
  }

  changeStepParam = (newStep) => {
    const { history, match } = this.props;
    const { hash } = match.params;
    history.replace(`/settings/${newStep}`);
  };

  changeTab(tab) {
    let hash = '';
    if (
      this.props.match.path === '/profile/:hash' ||
      this.props.match.path === '/profile/:hash/docs/:category/:doc/:id'
    ) {
      hash = '?hash=' + this.props.match.params.hash;
    }
    this.props.dispatch(userActions.getProfile(hash));
    this.changeStepParam(tab);
    this.props.dispatch(permissionActions.getPermission());
    this.setState({ step: tab });
  }

  //Change the reason for unavailability
  changeUnavailabilityReason = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      unavailableDescriptionErr: '',
      unavailableErr: '',
    });
    e.target.setAttribute('errors', '');
  };

  setStatusReturn(status) {
    if (Number(this.state.unavailableReason) === Number(0)) {
      this.setState({
        unavailableErr: 'error',
      });
      return;
    }
    if (!this.state.otherReason.trim()) {
      this.setState({
        unavailableDescriptionErr: 'error',
      });
      return;
    }
    let step;
    if (status) {
      step = '2a';
    } else {
      step = '2b';
      this.setState({
        returnDate: '',
      });
    }

    this.setState({ statusStep: step });
  }
  setStep(step) {
    this.setState({ statusStep: step });
  }

  handleDateChange(date) {
    this.setState({
      returnDateField: date,
      returnDate: date.format('MM/DD/YY'),
    });
  }

  changeStatus(status, statVal) {
    if (status) {
      let stat = statVal === 'Available' ? 'Unavailable' : 'Available';

      let data = new FormData();
      if (
        this.props.match.path === '/profile/:hash' ||
        this.props.match.path === '/profile/:hash/docs/:category/:doc/:id'
      ) {
        data.append('hash', this.props.match.params.hash);
      }
      data.append('end_date', this.state.returnDate);
      data.append('status', stat);
      data.append(
        'unavailableReason',
        this.state.unavailableReason ? this.state.unavailableReason : 0,
      );

      data.append(
        'otherReason',
        this.state.otherReason ? this.state.otherReason : '',
      );

      if (
        this.props.match.path === '/profile/:hash' ||
        this.props.match.path === '/profile/:hash/docs/:category/:doc/:id'
      ) {
        const hash = '?hash=' + this.props.match.params.hash;
        if (this.props.match.params.hash === localStorage.getItem('hash')) {
          this.props.dispatch(userActions.changeSelfStatus(data));
        } else {
          this.props.dispatch(userActions.changeStatus(data, hash));
        }
      } else {
        this.props.dispatch(userActions.changeSelfStatus(data));
      }
      this.props.dispatch(notificationActions.getCount());
      this.setState({ status: stat, loader: true });
    }
  }

  editProfile() {
    this.setState({ step: 'EditProfile' });
  }
  cancel() {
    this.setState({ step: 'profile' });
  }

  viewHistory(hash, applnType = '') {
    this.setState(
      { step: 'ApplicationHistory', hash: hash, applnType }
    );
  }

  viewDetails(hash, applnType = '') {
    this.setState(
      { step: 'ViewApplicant', hash: hash, applnType }
    );
  }

  componentDidMount() {
    this.loadUserData();
    this.props.dispatch(chatActions.getConversationSettings());
  }

  loadUserData = () => {
    let hash = '';
    if (
      this.props.match.path === '/profile/:hash' ||
      this.props.match.path === '/profile/:hash/docs/:category/:doc/:id'
    ) {
      hash = '?hash=' + this.props.match.params.hash;
    }
    this.props.dispatch(userActions.getProfile(hash));
    this.props.dispatch(permissionActions.getPermission());

    // Add missing inventory API call (same as Profile.jsx)
    if (this.props.match.params.hash) {
      let data = new FormData();
      data.append('hash', this.props.match.params.hash);
      this.props.dispatch(inventoryActions.getInventoryList(data));
    }

    if (this.props.match.path === '/profile/:hash/docs/:category/:doc/:id') {
      this.changeTab('docs-list');
    }
  }

  componentDidUpdate(prevProps) {
    const { user } = this.props;
    if (user?.changeStatusSuccess && !prevProps.user?.changeStatusSuccess) {
      this.statusCloseModal();
      this.setState({ reloadKey: this.state.reloadKey + 1, loader: false });
    }

    if (user?.changeStatusFailure && !prevProps.user?.changeStatusFailure) {
      this.statusCloseModal();
      this.setState({ loader: false });
    }

    // Handle user data changes (e.g., when navigating back from Profile.jsx)
    const currentUserHash = user?.profile?.data?.hash || user?.items?.data?.hash;
    const prevUserHash = prevProps.user?.profile?.data?.hash || prevProps.user?.items?.data?.hash;

    if (currentUserHash && currentUserHash !== prevUserHash) {
      // User data changed, force a reload of the profile
      this.setState({ reloadKey: this.state.reloadKey + 1 });
    }

    // Handle navigation changes (when coming back from Profile.jsx)
    if (this.props.match.params.hash !== prevProps.match.params.hash) {
      this.loadUserData();
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const updates = {};

    // Handle permission updates
    if (nextProps.permission?.permissions &&
      (!prevState.permission || prevState.permission.length === 0)) {
      updates.permission = nextProps.permission.permissions.data;
    }

    // Handle user data updates
    if (nextProps.user?.items?.data) {
      const userData = nextProps.user.items.data;
      const admin = userData.is_admin !== 0 ? true : false;

      if (
        nextProps.match.path === '/profile/:hash' ||
        nextProps.match.path === '/profile/:hash/docs/:category/:doc/:id'
      ) {
        updates.h1 = userData.first_name + ' ' + userData.last_name;
        updates.admin = admin;
        updates.namePrefix = userData.first_name;
      } else {
        updates.h1 = 'Profile & Settings';
        updates.admin = admin;
        updates.namePrefix = 'you';
      }

      updates.applicant_hash = userData.applicant_hash;
      updates.status = userData.active;
      updates.available = userData.active === 'Available' ? true : false;
      updates.email = userData.email_address || '';
    }

    // Handle profile data updates (for when navigating back from Profile.jsx)
    if (nextProps.user?.profile?.data) {
      const userData = nextProps.user.profile.data;
      const admin = userData.is_admin !== 0 ? true : false;

      if (
        nextProps.match.path === '/profile/:hash' ||
        nextProps.match.path === '/profile/:hash/docs/:category/:doc/:id'
      ) {
        updates.h1 = userData.first_name + ' ' + userData.last_name;
        updates.admin = admin;
        updates.namePrefix = userData.first_name;
      } else {
        updates.h1 = 'Profile & Settings';
        updates.admin = admin;
        updates.namePrefix = 'you';
      }

      updates.applicant_hash = userData.applicant_hash;
      updates.status = userData.active;
      updates.available = userData.active === 'Available' ? true : false;
      updates.email = userData.email_address || '';
    }

    return Object.keys(updates).length > 0 ? updates : null;
  }

  handleOnClickHandbook(fileUrl) {
    if (!fileUrl) {
      console.warn('Handbook link is not available');
      return;
    }

    try {
      // If it's already a full URL, use it directly
      if (fileUrl.startsWith('http://') || fileUrl.startsWith('https://')) {
        window.open(fileUrl);
      } else {
        // If it's a relative path, construct the full URL
        const baseUrl = config.apiUrl || window.location.origin;
        const fullUrl = fileUrl.startsWith('/') ? `${baseUrl}${fileUrl}` : `${baseUrl}/${fileUrl}`;
        window.open(fullUrl);
      }
    } catch (error) {
      console.error('Error opening handbook link:', error);
      window.open(fileUrl);
    }
  }

  openDdformConfirmModal() {
    this.setState({ send_dd_form_confirm: true });
  }

  ddFormConfirmCloseModal() {
    this.setState({
      send_dd_form_confirm: false,
    });
  }

  sendDDForm() {
    if (this.props.user.items?.data?.hash) {
      this.setState({
        ...this.state,
        sendingDDForm: true,
        send_dd_form_confirm: false,
      });
      let data = new FormData();
      data.append('user_hash', this.props.user.items.data.hash);
      profileService
        .sendDDForm(data)
        .then((res) => {
          if (res.success) {
            toast.success(res.message);
          } else {
            handleErrorResponse(res);
          }
          this.setState({
            ...this.state,
            sendingDDForm: false,
          });
        })
        .catch((error) => {
          toast.error('Failed to send email to user.');
          this.setState({
            ...this.state,
            sendingDDForm: false,
          });
        });
    } else {
      toast.error('An unexpected error occurred.');
    }
  }

  documentRequest(hash, doc_request) {
    this.setState({ doc_request });
    docsService.requestToFillDocs(hash, doc_request).then(
      (res) => {
        this.setState({
          request_rehire_doc_status: res.success,
          request_rehire_doc: true,
        });
        const profileHash = '?hash=' + (this.props.user?.items?.data?.hash || this.props.user?.profile?.data?.hash);
        this.props.dispatch(userActions.getProfile(profileHash));
      },
      (err) => console.log(err),
    );
  }

  docRequestModalClose() {
    this.setState({ request_rehire_doc: false });
  }

  downloadAllDocuments(event, rehire = false, giss = false) {
    let hash = this.props.user?.items?.data?.hash || this.props.user?.profile?.data?.hash;
    let params = {
      uid: this.props.user?.profile?.data?.hash,
      signature: this.props.chat?.settings?.signature,
    };
    let url = new URL(`${config.apiUrl}/docs/download/${hash}`);
    rehire &&
      (url = new URL(`${config.apiUrl}/docs/download/${hash}?rehire=true`));
    giss && (url = new URL(`${config.apiUrl}/docs/download/${hash}?giss=true`));
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key]),
    );
    window.open(url.href);
  }

  downloadAllDocumentsAsPDF(event, rehire = false, giss = false) {
    let hash = this.props.user?.items?.data?.hash || this.props.user?.profile?.data?.hash;
    let params = {
      uid: this.props.user?.profile?.data?.hash,
      signature: this.props.chat?.settings?.signature,
    };
    let url = new URL(`${config.apiUrl}/docs/download/pdf/${hash}`);
    rehire &&
      (url = new URL(`${config.apiUrl}/docs/download/pdf/${hash}?rehire=true`));
    giss &&
      (url = new URL(`${config.apiUrl}/docs/download/pdf/${hash}?giss=true`));

    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key]),
    );
    window.open(url.href);
  }

  render() {
    const { permission, user } = this.props;
    const userStatus = this.state.status;
    const available = this.state.available;
    let permList = [];
    if (permission.permissions) {
      permList = permission.permissions.data;
    }

    let editPerm = true,
      userItem;
    if (this.props.user.profile) {
      userItem = this.props.user.profile;
    } else if (this.props.user.items) {
      userItem = this.props.user.items;
    }

    // Use admin status from state (set in getDerivedStateFromProps)
    const admin = this.state.admin || false;

    // Use namePrefix from state
    const namePrefix = this.state.namePrefix || 'you';

    if (userItem && userItem.data) {
      if (
        this.props.match.path === '/profile/:hash' ||
        this.props.match.path === '/profile/:hash/docs/:category/:doc/:id'
      ) {
        editPerm = permList.includes('Status Update') ? true : false;
      }
    }

    let userData = user.profile?.data || {};
    const authUser = this.props.user.profile?.data ?? {};
    const userDataForHeader = this.props.user.items?.data ?? {};

    // Ensure we have proper profile data for the header
    // Prioritize user.profile.data, then user.items.data, then fallback to empty object
    const profileForHeader = userData || userDataForHeader || userItem?.data || {};



    return (
      <div>
        <div>
          <div className='settings_container settings-pre-wrapper'>
            <div className='breadcrumbs'>
              <div className='page_title float'>
                <h1>{this.state.h1}</h1>
                <div className='btn_list'>
                  {this.state.step === 'docs-list' ? (
                    <DocumentButtons
                      user={profileForHeader}
                      permList={permList}
                      requestRehireDoc={this.state.request_rehire_doc}
                      docRequest={this.state.doc_request}
                      requestRehireDocStatus={this.state.request_rehire_doc_status}
                      onDocumentRequest={this.documentRequest}
                      onDownloadAllDocuments={this.downloadAllDocuments}
                      onDownloadAllDocumentsAsPDF={this.downloadAllDocumentsAsPDF}
                      onDocRequestModalClose={this.docRequestModalClose}
                    />
                  ) : (
                    <>
                      <Link to={`/fire-history/${profileForHeader?.hash}`}>
                        <button
                          style={{ fontSize: '11px', padding: '6px 16px' }}
                          className='button print'
                        >
                          Fire History
                        </button>
                      </Link>

                      <Link to={`/fire-history/${profileForHeader?.hash}/legacy`}>
                        <button
                          style={{ fontSize: '11px', padding: '6px 16px' }}
                          className='button print'
                        >
                          Legacy Fire History
                        </button>
                      </Link>

                      {permList.includes('Manage Passwords') && (
                        <ChangePassword
                          userType='user'
                          user={profileForHeader}
                          isAdmin={admin}
                        />
                      )}

                      <button
                        style={{ fontSize: '11px', padding: '6px 16px' }}
                        className='button print'
                        onClick={() => window.print()}
                      >
                        Print
                      </button>

                      {permList.includes('Message Employees') && (
                        <button
                          style={{ fontSize: '11px', padding: '6px 16px' }}
                          className='button edit_resource'
                          onClick={this.mailSendOpenModal.bind(this)}
                        >
                          Message
                        </button>
                      )}

                      {permList.includes('Status Update') && (
                        <button
                          style={{ fontSize: '11px', padding: '6px 16px' }}
                          className='button edit_resource'
                          onClick={this.statusOpenModal.bind(this)}
                        >
                          Edit Status
                        </button>
                      )}

                      {(permList.includes('Modify SMS Notification Preference') ||
                        profileForHeader?.id == userData.id) &&
                        userData && (
                          <SmsNotification
                            initialStatus={userData.sms_notify}
                            providerOptedOutStatus={userData.sms_provider_opt_out}
                            type={profileType.EMPLOYEE}
                            id={userData.id}
                            customClass={'edit_resource xs-font'}
                          />
                        )}

                      {permList.includes('Send DD Form') && (
                        <button
                          className='button edit_resource'
                          onClick={this.openDdformConfirmModal.bind(this)}
                          disabled={this.state.sendingDDForm}
                          style={{ fontSize: '11px', padding: '6px 16px' }}
                        >
                          Send DD Form
                        </button>
                      )}

                      {/* Settings-specific buttons */}
                      <button
                        className='button'
                        style={{ fontSize: '11px', padding: '6px 16px' }}
                        onClick={() =>
                          this.handleOnClickHandbook(
                            'https://d2t6semrip28lv.cloudfront.net/doc/FinalCompanyPolicy2026AI.pdf',
                          )
                        }
                      >
                        View Handbook
                      </button>
                      <a
                        className='button'
                        href={`${config.companyWebsite}/`}
                        rel='noopener noreferrer'
                        target='_blank'
                        style={{
                          textAlign: 'center',
                          fontSize: '11px',
                          padding: '6px 12px',
                          color: 'white',
                        }}
                      >
                        Book Training Courses
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-lg-12'>
                <div className='inner_head'>
                  <h2
                    className={this.state.step === 'profile' ? 'active' : ''}
                    onClick={this.changeTab.bind(this, 'profile')}
                  >
                    Profile
                  </h2>

                  <h2
                    className={
                      this.state.step === 'docs-list' ? 'active' : ''
                    }
                    onClick={this.changeTab.bind(this, 'docs-list')}
                  >
                    Documents
                  </h2>
                  <h2
                    className={
                      this.state.step === 'qualifications' ? 'active' : ''
                    }
                    onClick={this.changeTab.bind(this, 'qualifications')}
                  >
                    Qualifications
                  </h2>
                  <h2
                    className={
                      this.state.step === 'trainings' ? 'active' : ''
                    }
                    onClick={this.changeTab.bind(this, 'trainings')}
                  >
                    Trainings
                  </h2>

                  {admin &&
                    this.props.match.path !== '/profile/:hash' &&
                    this.props.match.path !==
                    '/profile/:hash/docs/:category/:doc/:id' && (
                      <h2
                        className={
                          this.state.step === 'permissions' ? 'active' : ''
                        }
                        onClick={this.changeTab.bind(this, 'permissions')}
                      >
                        Permissions
                      </h2>
                    )}
                  {this.state.permission.includes('Bulletin Board') &&
                    this.props.match.path !== '/profile/:hash' &&
                    this.props.match.path !==
                    '/profile/:hash/docs/:category/:doc/:id' && (
                      <h2
                        className={
                          this.state.step === 'bulletin' ? 'active' : ''
                        }
                        onClick={this.changeTab.bind(this, 'bulletin')}
                      >
                        Bulletin Board
                      </h2>
                    )}
                  {this.state.permission.includes(
                    'Manage System Notification',
                  ) && (
                      <h2
                        className={
                          this.state.step === 'system-management' ? 'active' : ''
                        }
                        onClick={this.changeTab.bind(this, 'system-management')}
                      >
                        System Management
                      </h2>
                    )}
                  {profileForHeader?.applicant_hash && (
                    <h2
                      className={
                        this.state.step === 'application' ? 'active' : ''
                      }
                      onClick={this.changeTab.bind(this, 'application')}
                    >
                      Application
                    </h2>
                  )}
                </div>
                <div className='tab-contents'>
                  {this.state.step === 'profile' && (
                    (this.props.user?.profile?.data?.hash || this.props.user?.items?.data?.hash) ? (
                      <ViewProfile
                        userHash={this.props.user?.profile?.data?.hash || this.props.user?.items?.data?.hash}
                        authUser={this.props.user?.profile?.data || this.props.user?.items?.data || {}}
                        permList={this.state.permission}
                        changeTab={this.changeTab}
                        reloadKey={this.state.reloadKey}
                      />
                    ) : (
                      <div className='dashboard_expiration_date_no_data'>
                        <img
                          className='loader'
                          alt='Loader'
                          src={require('../assets/images/loader.gif').default}
                        />
                      </div>
                    )
                  )}
                  {this.state.step === 'docs-list' && (
                    <DocsList />
                  )}
                  {this.state.step === 'system-management' && (
                    <SystemManage />
                  )}
                  {this.state.step === 'application' &&
                    this.props.user?.items?.data?.applicant_hash && (
                      <ApplicantsTab
                        hash={this.props.user.items.data.applicant_hash}
                        isApplicationEditable={false}
                        applnType={this.state.applnType}
                        goBack=''
                        email={this.state.email ?? ''} editApplicant=''
                        viewHistory={this.viewHistory}
                      />
                    )}
                  {this.state.step === 'ApplicationHistory' && (
                    <ApplicationHistory
                      hash={this.state.hash}
                      applnType={this.state.applnType}
                      goBack={() => this.props.goBack()}
                      viewDetails={this.viewDetails}
                    />
                  )}
                  {this.state.step === 'management' && (
                    <Management />
                  )}
                  {this.state.step === 'bulletin' && (
                    <BulletinBoard />
                  )}
                  {this.state.step === 'permissions' && (
                    <Permissions />
                  )}
                  {this.state.step === 'EditProfile' && (
                    <EditProfile {...this.props} cancel={this.cancel.bind(this)} />
                  )}
                  {this.state.step === 'trainings' && (
                    <ErrorBoundary>
                      <UpdateEmployeeTraining
                        userHash={this.props.user?.profile?.data?.hash}
                      />
                    </ErrorBoundary>
                  )}
                  {this.state.step === 'qualifications' && (
                    <ErrorBoundary>
                      <UserQualifications />
                    </ErrorBoundary>
                  )}
                </div>
              </div>
            </div>
            <Modal
              id='remove_popup'
              className='status_popup'
              open={this.state.send_dd_form_confirm}
              onClose={this.ddFormConfirmCloseModal.bind(this)}
              little
            >
              <div id='removePopup'>
                <div className='modal-head'>
                  <h4 className='modal-title'>Direct Deposit Form</h4>
                </div>
                <div className='modal-body'>
                  <label>
                    This will send an email to{' '}
                    {userData
                      ? userData.first_name + ' ' + userData.last_name
                      : 'this employee'}
                    , with Direct Deposit form link.
                  </label>
                  <br />
                  <button
                    className='button grey'
                    onClick={this.ddFormConfirmCloseModal.bind(this)}
                  >
                    Cancel
                  </button>
                  <button
                    className='button'
                    onClick={this.sendDDForm.bind(this)}
                  >
                    Send
                  </button>
                </div>
              </div>
            </Modal>
            <Modal
              id='status_popup'
              className='status_popup'
              classNames={{ modal: 'status_popup' }}
              open={this.state.statusOpen}
              onClose={this.statusCloseModal.bind(this)}
              little
            >
              <div id='statusPopup'>
                <div className='modal-head'>
                  <h4 className='modal-title'>Current Status</h4>
                </div>
                {this.state.statusStep === '1' && (
                  <div className='modal-body'>
                    <div className='status_step step1'>
                      <label>
                        <span className='capitalize'>
                          {this.props.match.path === '/profile/:hash' ||
                            this.props.match.path ===
                            '/profile/:hash/docs/:category/:doc/:id'
                            ? namePrefix
                            : 'You'}
                        </span>
                        {this.props.match.path === '/profile/:hash' ||
                          this.props.match.path ===
                          '/profile/:hash/docs/:category/:doc/:id'
                          ? ' is: '
                          : ' are: '}
                        <span className='green'>{userStatus}</span>
                      </label>
                      <br></br>
                      <button
                        className='button'
                        onClick={this.setStep.bind(this, '2')}
                      >
                        Change Current Status
                      </button>
                      <p className='step_no'>
                        {userStatus === 'Available' ? '1/3' : '1/2'}
                      </p>
                    </div>
                  </div>
                )}
                {this.state.statusStep === '2' && available && (
                  <div className='modal-body'>
                    <div className='status_step step2'>
                      <label>Reason for Unavailability: </label>
                      <select
                        name='unavailableReason'
                        className='unavailability_reason'
                        value={this.state.unavailableReason}
                        onChange={this.changeUnavailabilityReason}
                        errors={this.state.unavailableErr}
                      >
                        <option value='0'>-- Select Reason --</option>
                        <option value='1'>Time Off</option>
                        <option value='2'>Sick</option>
                        <option value='3'>Injury</option>
                        <option value='4'>Other</option>
                      </select>
                      {(this.state.unavailableReason === '1' ||
                        this.state.unavailableReason === '2' ||
                        this.state.unavailableReason === '3' ||
                        this.state.unavailableReason === '4') && (
                          <div classNames='full-width'>
                            <textarea
                              rows='3'
                              maxLength={1200}
                              className='other_reason'
                              value={this.state.otherReason}
                              name='otherReason'
                              onChange={this.changeUnavailabilityReason}
                              errors={this.state.unavailableDescriptionErr}
                            />
                          </div>
                        )}
                      <label>Do you know when {namePrefix} will return?</label>
                      <button
                        className='button'
                        onClick={this.setStatusReturn.bind(this, true)}
                      >
                        Yes
                      </button>
                      <button
                        className='button grey'
                        onClick={this.setStatusReturn.bind(this, false)}
                      >
                        No
                      </button>
                      <p className='step_no'>2/3</p>
                    </div>
                  </div>
                )}
                {this.state.statusStep === '2' && !available && (
                  <div className='modal-body'>
                    <div className='status_step step2'>
                      <label>Make Available?</label>
                      <button
                        className='button'
                        onClick={this.changeStatus.bind(this, true, userStatus)}
                        disabled={this.state.loader}
                      >
                        Yes
                      </button>
                      <button
                        className='button grey'
                        onClick={this.statusCloseModal.bind(this)}
                        disabled={this.state.loader}
                      >
                        No
                      </button>
                      <p className='step_no'>2/2</p>
                    </div>
                  </div>
                )}
                {this.state.statusStep === '2a' && (
                  <div className='modal-body'>
                    <div className='status_step step4'>
                      <label>Choose date of return:</label>
                      <DatePicker
                        className='returnDateField'
                        name='returnDateField'
                        selected={this.state.returnDateField}
                        onChange={this.handleDateChange.bind(this)}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode='select'
                        minDate={moment()}
                      />
                      <button
                        className='button btn_margin'
                        onClick={this.setStep.bind(this, '3')}
                      >
                        Next
                      </button>
                      <p className='step_no'>2/3</p>
                    </div>
                  </div>
                )}
                {this.state.statusStep === '2b' && (
                  <div className='modal-body'>
                    <div className='status_step step2'>
                      <label>Make Unavailable?</label>
                      <button
                        className='button'
                        onClick={this.changeStatus.bind(this, true, userStatus)}
                        disabled={this.state.loader}
                      >
                        Yes
                      </button>
                      <button
                        className='button grey'
                        onClick={this.statusCloseModal.bind(this)}
                        disabled={this.state.loader}
                      >
                        No
                      </button>
                      <p className='step_no'>3/3</p>
                    </div>
                  </div>
                )}
                {this.state.statusStep === '3' && (
                  <div className='modal-body'>
                    <div className='status_step step5'>
                      <label>
                        Are you sure you want to switch {namePrefix} to
                        Unavailable?
                      </label>
                      <p>
                        (returning{' '}
                        {this.state.returnDate === ''
                          ? moment().format('MM/DD/YYYY')
                          : formatDate(this.state.returnDate)}
                        )
                      </p>
                      <button
                        className='button'
                        onClick={this.changeStatus.bind(this, true, userStatus)}
                        disabled={this.state.loader}
                      >
                        Yes
                      </button>
                      <button
                        className='button grey'
                        onClick={this.statusCloseModal.bind(this)}
                        disabled={this.state.loader}
                      >
                        No
                      </button>
                      <p>Time off must be approved by your supervisor.</p>
                      <p className='step_no'>3/3</p>
                    </div>
                  </div>
                )}
              </div>
            </Modal>
            <Modal
              id='mail_send_popup'
              className='status_popup'
              open={this.state.mailSendOpen}
              onClose={this.mailSendCloseModal.bind(this)}
              little
            >
              <div id='mailSendPopup'>
                <div className='modal-head'>
                  <h4 className='modal-title'>Custom Message</h4>
                </div>
                <div className='modal-body'>
                  <div className='cust_email_options'>
                    <div className='option_email'>
                      <input
                        type='checkbox'
                        name='sendEmail'
                        checked={!!this.state.sendEmail}
                        onChange={this.handleCheckbox}
                      />
                      <span>Email</span>
                      <div className='clearfix' />
                    </div>
                    <div className='option_sms'>
                      <input
                        type='checkbox'
                        name='sms'
                        checked={!!this.state.sms}
                        onChange={this.handleCheckbox}
                      />
                      <span>SMS</span>
                      <div className='clearfix' />
                    </div>
                  </div>
                  <textarea
                    name='message'
                    cols='80'
                    rows='10'
                    value={this.state.message}
                    onChange={this.handleChange.bind(this)}
                  />

                  <p className='step_no'>
                    Signature will automatically be included.
                  </p>

                  <button
                    className='button grey'
                    style={{ marginRight: '10px' }}
                    onClick={this.mailSendCloseModal.bind(this)}
                  >
                    Cancel
                  </button>
                  <button
                    className='button'
                    onClick={this.sendMail.bind(this, profileForHeader?.hash)}
                  >
                    Send
                  </button>
                </div>
              </div>
            </Modal>
            {this.state.alertPop && (
              <AlertPopup
                head={this.state.alertHead}
                message={this.state.alertMsg}
                alertFunction={this.state.alertFunction}
                close={this.closeAlert.bind(this)}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

Settings.propTypes = {
  match: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  permission: PropTypes.object.isRequired,
  inventory: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const { applicants, user, permission, inventory, chat } = state;
  return {
    applicants,
    user,
    permission,
    inventory,
    chat,
  };
}
const connectedHomePage = connect(mapStateToProps)(Settings);
export { connectedHomePage as Settings };
